
import React from "react";
import { Label } from "@/components/ui/label";
import CustomDatePicker from "@/components/DatePicker/CustomDatePicker";

interface DatePickerFieldProps {
  id: string;
  label: string;
  value?: string;
  onChange: (value: string | undefined) => void;
  placeholder?: string;
}

const DatePickerField = ({
  id,
  label,
  value,
  onChange,
  placeholder = "Select date",
}: DatePickerFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <CustomDatePicker
        id={id}
        label=""
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default DatePickerField;
